import { useCallback, useEffect, useState } from "react";

/** Same key as used in sessionStorage for the enrollment form step. */
export const STEP_SESSION_STORAGE_KEY = "step";

export const usePersistentCurrentStep = (defaultStep: number = 1) => {
  const [currentStep, setCurrentStepInternal] = useState(() => {
    const storedStep = sessionStorage.getItem(STEP_SESSION_STORAGE_KEY);
    return storedStep ? parseInt(storedStep, 10) : defaultStep;
  });

  const setCurrentStep = useCallback(
    (action: number | ((prev: number) => number)) => {
      setCurrentStepInternal((prev) => {
        const next =
          typeof action === "function"
            ? (action as (p: number) => number)(prev)
            : action;
        sessionStorage.setItem(STEP_SESSION_STORAGE_KEY, String(next));
        return next;
      });
    },
    [],
  );

  useEffect(() => {
    sessionStorage.setItem(STEP_SESSION_STORAGE_KEY, String(currentStep));
  }, [currentStep]);

  return [currentStep, setCurrentStep] as const;
};